import { SwitchToggle } from '@zappyrent/hundop';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from 'styled-components';
import shallow from 'zustand/shallow';

import { IUser } from '../../../shared/ts/user';
import useStore from '../../../store';
import {
  StyledLabel,
  StyledSwitchToggleWrapper,
  StyledWrapper,
} from './UserType.styles';

const UserType = (): JSX.Element => {
  const { t } = useTranslation(['a11y']);
  const { user, updateUserById } = useStore(
    state => ({
      user: state.user,
      updateUserById: state.updateUserById,
    }),
    shallow,
  );
  const { id, type } = user as IUser;
  const [isLandlord, setIsLandlord] = useState<boolean>(type === 'landlord');
  const theme = useContext(ThemeContext);
  const handleOnChange = async (checked: boolean) => {
    setIsLandlord(checked);

    try {
      const user = isLandlord ? 'tenant' : 'landlord';
      const payload = { type: user } as IUser;

      updateUserById(id, payload);
    } catch (err) {
      console.error(err);
      setIsLandlord(!checked);
    }
  };

  return (
    <StyledWrapper>
      <StyledLabel>
        {isLandlord
          ? t('a11y:switchToTenantMode')
          : t('a11y:switchToLandlordMode')}
      </StyledLabel>
      <StyledSwitchToggleWrapper>
        <SwitchToggle
          checked={isLandlord}
          id="user_type"
          width={56}
          height={28}
          handleDiameter={16}
          onColor={theme.colors.cross.grayson}
          offColor={theme.colors.cross.grayson}
          onChange={(checked: boolean) => handleOnChange(checked)}
        />
      </StyledSwitchToggleWrapper>
    </StyledWrapper>
  );
};

export default UserType;
